import { Component, Input } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/services/common-services/common.service';
import { Router, ActivatedRoute } from '@angular/router';
import { first, groupBy } from 'lodash';
import {
  FileStatus,
  FileType,
  FileTypeLabel,
  RFQStatus,
  RFQStatusLabel,
  TemplateType,
  UserType,
} from 'src/app/shared/constants/constants';
import { downloadFiles, getRFQTemplateLabel } from 'src/app/shared/utils';
import { ToastrService } from 'ngx-toastr';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { RfqService } from '../services/rfq.service';
import { ConfirmationBoxComponent } from 'src/app/shared/elements/confirmation-box/confirmation-box.component';

export enum RfqTemplateType {
  Component = 'Component',
  Paint = 'Paint',
  RawMaterial = 'Raw Material',
  Refrigeration = 'Refrigeration'
}

interface RFQInfo {
  id: number;
  rfqName: string;
}
interface DocumentDetails {
  userType: string;
  documentUseFor: string;
  baseUrl: string;
}

@Component({
  selector: 'app-rfq-detail',
  templateUrl: './rfq-detail.component.html',
  styleUrls: ['./rfq-detail.component.scss'],
})
export class RfqDetailComponent {
  baseUrl = environment.BASE_URL;
  @Input() rfqInfo!: RFQInfo;
  rfqItem: any;
  attachedFiles: any[] = [];
  attachments: any[] = [];
  fileTypeGroup: Map<string, any> = new Map();
  FileTypeLabel: any = FileTypeLabel;

  RFQStatusLabel: any = RFQStatusLabel;
  RFQStatus: any = RFQStatus;
  FileType: any = FileType;
  fileStatus: any = FileStatus;
  templateType = TemplateType;
  UserType: any = UserType;

  Sendarchive: boolean = false;
  isMoreExpanded: boolean = false;
  saveButtonEnable: boolean = false;
  isExpanded: boolean = false;

  archivedPOFile: any;
  lineItems: any;
  custRfqId: any;
  companyId = localStorage.getItem('customercompanyId') || '';
  customerName!: string;

  resetFileUpload: boolean = false;
  documentInfo: DocumentDetails = {
    userType: UserType.Customer,
    documentUseFor: FileType.RFQ,
    baseUrl: this.baseUrl,
  };
  fileUploadConfig = {
    uploadLabel: 'Upload New Files',
    buttonName: 'Choose File',
    dragDropText: 'Drag & Drop File .xls, .xlsx,',
    isMultiple: true,
    fileSizeLimit: 10485760 * 10, // 100 mb in bytes
    fileLocation: `${UserType.Customer}/${this.companyId}/tooling`,
    fileFormats: '.xls, .xlsx', // supported file formats for file picker
  };

  constructor(
    private commonService: CommonService,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private http: HttpClient,
    private router: Router,
    private dialog: MatDialog,
    private rfqService: RfqService
  ) {}

  ngOnInit() {
    this.getRfqCustomerDetail(this.rfqInfo.id);
    this.getCustomerName();
  }
  close = () => {};
  updateRfqListData = () => {};
  getRfqCustomerDetail(customerRfqPrimaryId: number) {
    this.rfqService.getCustomerRfq(customerRfqPrimaryId).subscribe({
      next: (data: any) => {
        this.rfqItem = data.response;
        this.archivedPOFile = data.response.attachments.filter(
          (file: { fileStatus: string; fileType: string }) => {
            return (
              file.fileStatus == FileStatus.Archive &&
              file.fileType == FileType.PO
            );
          }
        );
        this.attachedFiles = this.rfqItem?.attachments;
        this.groupAttachmentsByFileType(this.rfqItem?.attachments);
        if (this.rfqItem?.status === RFQStatus.QUOTE_ACCEPTED) {
          this.changeLabels();
        }
      },
    });
  }

  getStatusLabel(status: any): string {
    return this.RFQStatusLabel[status];
  }
  getRFQTemplateLabel(rfqType: TemplateType): string {
    return getRFQTemplateLabel(rfqType);
  }
  /**Grouping of files based on file type**/
  getFileTypeLabel(fileType: any): string {
    return this.FileTypeLabel[fileType];
  }
  groupAttachmentsByFileType(filesData: any): any {
    const result: any = groupBy(filesData, 'fileType');
    this.fileTypeGroup = result;
  }
  getFileTypes() {
    return Object.entries(this.fileTypeGroup).map(([key, value]) => ({
      key,
      value,
    }));
  }
  downloadFile(id: number, fileName: string) {
    downloadFiles(this.baseUrl, this.commonService, this.toastr, id, fileName);
  }
  /**Grouping of files and download**/
  getCustomerName() {
    let apiURL = `${this.baseUrl}customer/company-management/getCompanyDetails?companyId=${this.companyId}`;
    this.commonService.getData(apiURL).subscribe((res) => {
      this.customerName = res.response.name;
    });
  }
  updateRFQFile() {
    let apiURL = `${this.baseUrl}rfq/customer/`;
    const payLoad = {
      customerId: Number(this.companyId),
      customerName: this.customerName,
      rfqTemplate: [first(this.rfqItem.rfqTemplate)],
      secondaryProcess: this.rfqItem.secondaryProcesses,
      material: this.rfqItem.materials,
      category: this.rfqItem.category,
      projectName: this.rfqItem.projectName,
      attachments: this.attachments,
      createdSource: 'portal',
      paymentTerm: this.rfqItem.paymentTerm,
      paymentTermRemarks: this.rfqItem.paymentTermRemarks,
      incoTerm: this.rfqItem.incoTerm,
      address: this.rfqItem.address,
      moq: this.rfqItem.moq,
      deliveryDate: this.rfqItem.deliveryDate,
      countryName: this.rfqItem.countryName,
      categoryOthers : this.rfqItem.categoryOthers,
      materialOthers : this.rfqItem.materialOthers
    };

    let subcategory: [] = this.rfqItem.subCategory;

    if (subcategory) {
      for (let val of subcategory) {
        payLoad.category.push(val);
      }
    }
    this.commonService.update(apiURL, this.rfqItem.id, payLoad).subscribe({
      next: (res: any) => {
        this.updateRfqListData();
      },
    });
  }
  acceptQuote() {
    const dialogRef = this.dialog.open(ConfirmationBoxComponent, {
      disableClose: true,
      data: {
        heading: 'Accept Quote',
        content: 'Are you sure you want to accept this quote?',
        btnConfirm: 'Confirm',
        btnCancel: 'Cancel',
      },
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        const payload = {
          adminRFQId: this.rfqItem.adminRFQId,
          customerRFQId: this.rfqItem.customerRfqPrimaryId,
          requestType: 'Accept',
        };
        this.rfqService.updatePoData(payload).subscribe({
          next: () => {
            this.toastr.success('Quote Accepted Successfully');
            this.updateRfqListData();
          },
          error: (error: HttpErrorResponse) => {
            this.toastr.error(error.error.status.error.message);
          },
        });
      }
    });
  }
  updatePOFile() {
    const dialogRef = this.dialog.open(ConfirmationBoxComponent, {
      disableClose: true,
      data: {
        heading: 'Upload PO',
        content: 'Are you sure you want to upload this file?',
        btnConfirm: 'Confirm',
        btnCancel: 'Cancel',
      },
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        const payload = {
          adminRFQId: this.rfqItem.adminRFQId,
          attachments: [
            {
              id: this.attachments[0].id,
              fileName: this.attachments[0].fileName,
              type: this.attachments[0].type,
              location: this.attachments[0].location,
              presignedUrl: this.attachments[0].presignedUrl,
              rfqTemplateType: this.attachments[0].rfqTemplateType,
              size: this.attachments[0].size,
              updatedOn: this.attachments[0].updatedOn,
              fileType: FileType.PO,
            },
          ],
          customerRFQId: this.rfqItem.customerRfqPrimaryId,
          requestType: 'Upload',
        };
        this.rfqService.updatePoData(payload).subscribe({
          next: () => {
            this.toastr.success('PO Raised Successfully');
            this.updateRfqListData();
          },
        });
      }
    });
  }
  updatePOStatus() {
    let apiURL = `${this.baseUrl}rfq/customer/${this.rfqItem.id}/PO_RAISED`;
    const payLoad = {};
    this.http.post(apiURL, this.rfqItem.id, payLoad).subscribe({
      next: (res: any) => {
        this.updateRfqListData();
      },
    });
  }
  changeLabels() {
    this.documentInfo.documentUseFor = FileType.PO;
    this.fileUploadConfig.uploadLabel = 'Upload P.O.';
    (this.fileUploadConfig.isMultiple = false),
      (this.fileUploadConfig.fileFormats = '.xls, .xlsx, .pdf'),
      (this.fileUploadConfig.dragDropText =
        'Drag & Drop File .xls, .xlsx, .pdf'),
      (this.fileUploadConfig.fileLocation = `${UserType.Customer}/rfq/${this.rfqItem.id}/${this.rfqItem?.rfqTemplate}/po`);
  }

  fileUploadEvent(fileUploadEvent: any, fileKey: string): void {
    const fileUploadData: any = fileUploadEvent;
    let dataItem: any = first(fileUploadData?.attachment);
    let payLoad = {
      id: dataItem?.id,
      fileName: dataItem?.fileName,
      fileType: FileType.Additional,
      rfqTemplateType: first(this.rfqItem.rfqTemplate),
      updatedOn: new Date(),
      fileExtension: dataItem?.type,
      size: dataItem?.size,
      type: '.' + dataItem?.type,
      uploadedBy: UserType.Customer,
      location: dataItem?.location,
      presignedUrl: dataItem?.presignedUrl,
    };
    this.attachments.push(payLoad);
    // console.log(this.attachments);
  }
  toggleAttachment() {
    (this.fileUploadConfig.fileFormats =
      '.jpeg, .jpg, .png, .pdf, .doc, .docx, .zip, .dwg, .dxf, .dgn, .stl , .JPEG, .JPG, .PNG, .PDF, .DOC, .DOCX, .ZIP, .DWG, .DXF, .DGN, .STL'),
      (this.fileUploadConfig.dragDropText =
        'JPEG | JPG | PNG | PDF | DOC | DOCX | ZIP | DWG | DXF | DGN | STL | STEP | IGES | STP'),
      (this.isExpanded = !this.isExpanded);
  }

  async downloadAllQuoteFiles(fileList: any): Promise<void> {
    if (fileList?.length > 0) {
      for (const item of fileList) {
        if (
          (item.fileType == FileType.Quote_Tooling ||
            item.fileType == FileType.Quote_Component ||
            item.fileType == FileType.Quote_Capex ||
            item.fileType == FileType.Quote) &&
          item.fileStatus == FileStatus.Live
        ) {
          await this.downloadFile(item.id, item.fileName);
        }
      }
      this.toastr.success(`All files downloaded successfully`);
    }
  }

 RfqTemplateType = RfqTemplateType;

shouldShowProjectLife(): boolean {
  const templates: string[] = this.rfqItem?.rfqTemplate || [];
  const matchTemplates: string[] = Object.values(RfqTemplateType);
  return templates.some((t) => matchTemplates.includes(t));
}
}


